import { registerBlockType } from '@wordpress/blocks';
import { SelectControl } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody } from '@wordpress/components';
import { useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';


registerBlockType('custom-expertise-selection/block', {
    title: 'Dettaglio Expertise',
    icon: 'list-view',
    category: 'layout',
    attributes: {
        type: {
            type: 'string',
            default: 'settori',
        },
        expertise : {
            type: 'array',
            default: [],
        }
    },
    edit: ({ attributes, setAttributes }) => {
    
        const { type, expertise } = attributes;

        const fetchExpertise = postType => {
            if (!postType) return;

            apiFetch({path: `/wp/v2/${postType}`}).then(res => {
                setAttributes({expertise: res});
            })
        }

        useEffect(() => {
            if (type) {
                fetchExpertise(type);
            }
        }, [])

    
        return (
            <>
            <InspectorControls>
                <PanelBody title='Campi expertise'>
                    <SelectControl
                        label="Seleziona l'Expertise"
                        value={type}
                        options={[
                            { label: 'Settori', value: 'settori' },
                            { label: 'Aree Attività', value: 'aree_attivita' },
                        ]}
                        onChange={(newValue) => {
                            setAttributes({ type: newValue });
                            fetchExpertise(newValue)
                        }}
                    />
                </PanelBody>
            </InspectorControls>
            <div className={type == 'aree_attivita' ? 'expertise-preview activities' : 'expertise-preview branches'}>
                {expertise.length == 0 ? <p>Nessuna expertise disponibile</p> : ''}
                <div className='expertise-list'>
                    {expertise.map( exp => (
                        <p key={exp.id} className='expertise-name'>{exp.title.rendered}</p>
                    ))}
                </div>
                <div
                    className='expertise-details'
                    dangerouslySetInnerHTML={{ __html: expertise[0]?.content?.rendered }}
                />
            </div>
            </>
        );
    },
    save: () => {
        return null;
    },
});

